import { initAccordions } from '$c3base/accordion.js';

initAccordions();
const header = document.querySelector('.page-header'),
	hamburger = document.querySelector('.hamburger'),
	nav = header.querySelector('nav[role=navigation]');

function initNavAnimation() {

	if( window.matchMedia('(min-width:1024px)').matches ) return;

	function getNavHeight(){
		nav.style.position = 'absolute';
		nav.style.visibility = 'hidden';
		nav.style.display = 'block';
		let height = nav.getBoundingClientRect().height;
		nav.style.height = 0;
		nav.style.position = '';
		nav.style.visibility = '';
		nav.style.display = '';

		return height + "px";
	}

	const navAnimation = new Animation(new KeyframeEffect(nav,
		[
			{height: 0, marginTop: 0, borderTopWidth:0},
			{height: getNavHeight(), marginTop: '1rem', borderTopWidth:'1px'}
		],
		{fill: "forwards", duration: 400, delay: 200, easing: 'ease-out'})),
		overlay = document.createElement('div'),
		overlayAnimation = new Animation( new KeyframeEffect(overlay,{opacity: [0,1]}, {fill: "forwards",duration: 600, easing: 'ease-out'}))
	let direction = 'forwards';


	overlay.classList.add('overlay');
	document.body.append( overlay );


	navAnimation.onfinish = () => {
		if ( direction === 'reverse' ) {
			header.classList.remove('has-open_nav');
			document.body.classList.remove('no-overflow');
		}
	};

	hamburger.addEventListener('click', () => {


		if ( false === header.classList.contains('has-open_nav') ) {
			if ( direction === 'reverse' ) {
				direction = 'forwards';
				navAnimation.reverse();
				overlayAnimation.reverse();
			}
			else {
				navAnimation.play();
				overlayAnimation.play();
			}
			document.body.classList.add('no-overflow');
			header.classList.add('has-open_nav');
		}
		else {
			direction = 'reverse';
			navAnimation.reverse();
			overlayAnimation.reverse();
		}

	});
}

initNavAnimation();


var mainContent = document.querySelector('#main');
animateElement(mainContent.querySelectorAll('.frame:not(.frame-type-grid.frame-layout-0)'));

function animateElement( elements, callback, prepareItem ) {

	if ( !callback ) callback = function ( entries ) {
		entries.forEach(function ( entry ) {
			if ( entry.isIntersecting ) {
				entry.target.classList.remove('out-of-bounds');
				entry.target.classList.add('in-bounds');
			}
			else if ( !entry.target.classList.contains('in-bounds') ) {
				entry.target.classList.add('out-of-bounds');
			}
		});
	};

	// if ( !prepareItem )
	// 	prepareItem = function ( el, idx ) {
	// 		el.classList.add('out-of-bounds');
	// 		// el.style.setProperty('--animation-wait', Math.max((idx * 10),800) + 'ms');
	// 	};

	let observer = new IntersectionObserver(callback, {
		rootMargin: '0px 0px 0px 0px', threshold: 0
	});

	elements.forEach(function ( el, idx ) {
		// prepareItem(el, idx);
		observer.observe(el);
	});

}


const links = document.querySelectorAll('a,.menu-link,.button');
links.forEach(( el ) => {

	el.addEventListener('click', ( evt ) => {
		let el = evt.target, target = el.getAttribute('href');

		if ( target.substring(0, 1) === '#' ) {
			evt.preventDefault();
			window.scrollTo({top: document.getElementById(target.substring(1)).offsetTop, behavior: 'smooth'});
		}
	});
});

document.querySelectorAll('.button').forEach(( el ) => {
	el.addEventListener('mouseenter', function ( evt ) {
		let shine = document.createElement('DIV');
		shine.classList.add('shine');
		evt.target.appendChild(shine);
		shineEffect(evt.target);
	});
	el.addEventListener('mouseleave', function ( evt ) {
		evt.target.querySelector('.shine').remove();
	});
});

function shineEffect( element ) {
	var $shineContainer = element, $shine = element.querySelector('.shine'), w = window.innerWidth, //window width
		h = window.innerHeight; //window height


	element.addEventListener('mousemove', function ( e ) {
		var offsetX = 0.5 - e.pageX / w, //cursor position X
			offsetY = 0.5 - e.pageY / h, //cursor position Y

			// dx = e.pageX - w / 2, //@w/2 = center of $shineContainer
			// dy = e.pageY - h / 2, //@h/2 = center of $shineContainer

			el = element.querySelector('.shine'), button_dx = (el.clientWidth / 2) - e.offsetX, //e.pageX - (el.clientWidth / 2),
			button_dy = (el.clientHeight / 2) - e.offsetY, //e.pageY - (el.clientHeight / 2),
			koe = el.clientWidth / el.clientHeight, dx = button_dx * -1, dy = (button_dy * koe) * -1,

			theta = Math.atan2(dy, dx), //angle between cursor and center of $shineContainer in RAD
			angle = theta * 180 / Math.PI - 90, //convert rad in degrees
			offsetPoster = 1,//$shineContainer.dataset.offset,
			transformPoster = 'translateY(' + -offsetX * offsetPoster + 'px) rotateX(' + (-offsetY * offsetPoster) + 'deg) rotateY(' + (offsetX * (offsetPoster * 2)) + 'deg)'; //poster transform


		//get angle between 0-360
		if ( angle < 0 ) {
			angle = angle + 360;
		}

		//gradient angle and opacity
		$shine.style.background = 'linear-gradient(' + angle + 'deg, rgba(255,255,255,.55) 0%,rgba(255,255,255,0) 80%)';


		//poster transform
		// $shineContainer.style.transform = transformPoster;
	});
}
